module.exports = __webpack_public_path__ + "img/Our-logo.aadc21e6.png";